export const loadGoogleMaps = () => new Promise<void>((resolve, reject) => {
  const eventName = "googleMapsLoaded";

  if (window.googleMapsLoading) {
    document.addEventListener(eventName, () => {
      resolve();
    });
  } else {
    if (window.google) {
      resolve();
    } else {
      window.googleMapsLoading = true;
      let script = document.createElement("script");
      script.src =
        "//maps.google.com/maps/api/js?key=AIzaSyCivlNezJSlI4yOpL67LEKwMJL4NWw3Pyo";
      script.onload = () => {
        window.googleMapsLoading = false;

        const event = new Event(eventName);
        document.dispatchEvent(event);
        resolve();
      };

      document.body.appendChild(script);
    }
  }
});
